import React, { createContext } from 'react';
import { Context } from './types';

export const initialState: Partial<Context> = {
  selected: [],
};

export default createContext(initialState);
